import { createAsyncThunk } from '@/redux/createAsyncThunk';
import { getAuthToken } from '@/redux/modules/user';
import { getDeployment } from '@/redux/modules/config';
import {
    getHouseBillingStatus,
    postHouseBillingAccountStatus,
} from '@/redux/modules/billingManagement/houseBillingStatus/houseBillingStatus.api';
import {
    getHouseBillingStatusAccountStatus,
    shouldFetchHouseBillingStatus,
} from '@/redux/modules/billingManagement/houseBillingStatus/houseBillingStatus.selectors';
import {
    HouseBillingAccountStatus,
    HouseBillingStatus,
} from '@/redux/modules/billingManagement/houseBillingStatus/houseBillingStatus.types';

type FetchHouseBillingStatusParams = {
    force?: boolean;
    houseId: number;
};

export const fetchHouseBillingStatus = createAsyncThunk<HouseBillingStatus, FetchHouseBillingStatusParams>(
    'la/ui/houseBillingStatus/fetchHouseBillingStatus',
    async ({ houseId }, { getState }) => {
        const state = getState();
        const authToken = getAuthToken(state);
        const deployment = getDeployment(state);

        const { payload } = await getHouseBillingStatus({
            authToken,
            deployment,
            houseId,
        });
        return payload;
    },
    {
        condition: ({ force, houseId }, { getState }) => {
            return force || shouldFetchHouseBillingStatus(getState(), houseId);
        },
    }
);

type SaveHouseBillingAccountStatusParams = {
    accountStatus: HouseBillingAccountStatus;
    houseId: number;
};

export const saveHouseBillingAccountStatus = createAsyncThunk<void, SaveHouseBillingAccountStatusParams>(
    'la/ui/houseBillingStatus/saveHouseBillingAccountStatus',
    async (params, { getState }) => {
        const state = getState();
        const authToken = getAuthToken(state);
        const deployment = getDeployment(state);

        await postHouseBillingAccountStatus({
            ...params,
            authToken,
            deployment,
        });
    },
    {
        condition: ({ accountStatus, houseId }, { getState }) => {
            const currentStatus = getHouseBillingStatusAccountStatus(getState(), houseId);
            return accountStatus !== currentStatus;
        },
    }
);
